export default "__VITE_PUBLIC_ASSET__44e2a350__"